/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, ContentChildren, QueryList } from '@angular/core';
import { CardColComponent } from '../card-col/card-col.component';

@Component({
  selector: 'ods-card-item',
  template: `<ng-content select="ods-card-col" /><ng-content select="ods-card-col-right" />`,
  host: {
    class:
      'relative flex flex-1 flex-col gap-4 p-4 first:rounded-t-md last:rounded-b-md @xl:flex-row hover:bg-background-100 has-[button:hover]:bg-inherit focus-within:outline-focus focus-within:z-10 focus-within:outline-2 focus-within:outline-offset-2 focus-within:has-[button:focus]:outline-hidden',
    '[attr.role]': 'isListItem ? "listitem" : null',
  },
})
export class CardItemComponent {
  @ContentChildren(CardColComponent) cardCols!: QueryList<CardColComponent>;

  private _isListItem: boolean;

  public set isListItem(value: boolean) {
    this._isListItem = value;
    this.cardCols.forEach((col: CardColComponent) => this.setIsListItemForCol(col));
  }

  public get isListItem() {
    return this._isListItem;
  }

  setIsListItemForCol(col: CardColComponent): void {
    col.isListItem = this.isListItem;
  }
}
